import { useEffect, useState } from "react"
import Copyright from "../common/Copyright"
import SimpleSelection from "../common/SimpleSelection"
import MainContainer from "../common/MainContainer"
import EntitiesListing from "./EntitiesListing"
import useUser from "../../hooks/useUser"
import { useProject } from "../../context/ProjectContext"
import AddChip from "../common/ActionChip/AddChip"
import { itemSelection } from "../../models/itemSelection.model"


interface EntitiesSettingsProps {
  setBlockScreen: (p: boolean) => void
  entity_type: string
  options?: itemSelection[]
}

const EntitiesSettings: React.FC<EntitiesSettingsProps> = ({
  setBlockScreen,
  entity_type,
  options = []
}) => {

  const { userAdmin }: any = useUser()
  const { selectedProject } = useProject()

  const defaultEntity = { 'entity': options[0] ?? { id: '', label: '' } }
  const [entitySelected, setEntitySelected] = useState(defaultEntity)

  const [openActionModal, setOpenActionModal] = useState(false)
  const [action, setAction] = useState<'view' | 'edit' | 'create'>('view')

  const handleChange = (event: React.ChangeEvent<HTMLInputElement> | { 'target': { 'name': any, 'value': any } }): void => {
    setEntitySelected({
      ...entitySelected,
      [event.target.name]: event.target.value
    });
  }

  const initComponent = () => {
    setBlockScreen(true)
    setBlockScreen(false)
  }

  useEffect(initComponent, [])

  return (
    <>
      <MainContainer>
        <div className="entities-actions-bar">
          <span className="entities-actions-bar-selector">

            <SimpleSelection
              label="Entidad"
              options={options}
              name={"entity"}
              value={entitySelected.entity}
              onChange={handleChange}
            />
          </span>
          {selectedProject && (
            <span className="entities-actions-bar-add-btn">
              <AddChip
                onClick={() => { setAction('create'); setOpenActionModal(true) }}
                label='Nueva Entidad'
              />
            </span>
          )}
        </div>

        <EntitiesListing
          openActionModal={openActionModal}
          setOpenActionModal={setOpenActionModal}
          action={action}
          setAction={setAction}
          canEdit={userAdmin}
          setBlockScreen={setBlockScreen}
          project_id={selectedProject}
          entity_type={entity_type}
          entity_name={entitySelected.entity.id as string}
        />

      </MainContainer>
      <Copyright marginBottom={'1rem'} />
    </>
  );
}

export default EntitiesSettings;